import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { LoginUser } from "../../Redux/LoginRedux";
import toast from "react-hot-toast";
import { Button } from "@mui/material";

function Login({ toggleForm }) {
  const [emailId, setEmailId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [userNotFound, setUserNotFound] = useState(false);
  const [isInvalidPass, setIsInvalidPass] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const validate = () => {
    if (emailId.trim() !== "" && password.trim() !== "") {
      login();
    } else {
      toast.error("EmailId and password are required.");
    }
  };

  const handleLogin = (e) => {
    e.preventDefault();
    validate();
  };

  const login = () => {
    const data = { emailId: emailId, password: password };
    dispatch(LoginUser(data))
      .then((response) => {
        if (response && response.accessToken) {
          sessionStorage.setItem("accessToken", response.accessToken);
          sessionStorage.setItem("refreshToken", response.refreshToken);
          localStorage.setItem("user", JSON.stringify(response.user));
          sessionStorage.setItem("authenticated", true);
          navigate("/myAccount/dashboard");
        } else {
          throw new Error(`${response.message.message}`);
        }
      })
      .catch((error) => {
        if (error === "Error: User not found") {
          setIsInvalidPass(false);
          setUserNotFound(true);
        }
        if (error === "Error: Invalid credentials") {
          setUserNotFound(false);
          setIsInvalidPass(true);
        }
      });
  };

  return (
    <div>
      <h5 className="text-center">Login</h5>
      <div style={{ padding: "25px" }}>
        <form onSubmit={handleLogin}>
          <div>
            <label htmlFor="loginEmail">
              Email Id <span className="requiredAsterisk">*</span>
            </label>
            <input
              type="email"
              id="loginEmail"
              name="loginEmail"
              className="form-control mb-3"
              onChange={(e) => setEmailId(e.target.value)}
              style={{ border: "1px solid #cccccc" }}
              required
            />
            {userNotFound && (
              <label htmlFor="incorrectemail" style={{ color: "red" }}>
                ! Incorrect Email
              </label>
            )}
          </div>
          <div className="form-group" style={{ position: "relative" }}>
            <label htmlFor="loginPassword">
              Password <span className="requiredAsterisk">*</span>
            </label>

            <input
              type={showPassword ? "text" : "password"}
              id="loginPassword"
              name="loginPassword"
              className="form-control mb-3"
              onChange={(e) => setPassword(e.target.value)}
              style={{ border: "1px solid #cccccc", paddingRight: "2.5rem" }}
              required
            />
            <i
              className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "10px",
                top: "58%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                fontSize: "1.2rem",
                color: "#666",
              }}
            ></i>

            {isInvalidPass && (
              <label htmlFor="incorrectPassword" style={{ color: "red" }}>
                ! Incorrect Password
              </label>
            )}
          </div>
          <div className="row">
            <div className="d-grid gap-2 col-8 mx-auto">
              <button
                className="btn"
                style={{ background: "#2b6930", color: "#fff" }}
                type="submit"
              >
                Login
              </button>
            </div>
          </div>
        </form>
        <div className="row mt-4">
          <div className="col-12 d-flex justify-content-between">
            <div className="col-6">
              <Button
                onClick={() => toggleForm("forgetPassword")}
                fullWidth
                color="success"
              >
                Forget Password
              </Button>
            </div>
            <div className="col-6 text-right">
              <Button
                onClick={() => toggleForm("register")}
                fullWidth
                color="success"
              >
                New Register
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
